'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var mergeCx = exports.mergeCx = function mergeCx(baseCx, customCx) {
  return function () {
    for (var _len = arguments.length, styles = Array(_len), _key = 0; _key < _len; _key++) {
      styles[_key] = arguments[_key];
    }

    var classes = [];
    classes.push(baseCx(styles));

    if (typeof customCx === 'function') {
      classes.push(customCx(styles));
    }

    return classes.join(' ');
  };
};